import "./gallery.css";

import React from "react";
import { Tabs, Tab } from "@material-ui/core";
import { Helmet } from "react-helmet";

import Header from "../sections/Header";
import LineSeparator from "../sections/LineSeparator";
import Contact from "../sections/Contact";
import GalleryTab from "./GalleryTab";

const styles = {
  tabs: {
    backgroundColor: "#fff",
    color: "#6F766B",
    textTransform: "none",
  },
  tab: {
    borderRight: "2px solid #C6D1C0",
    alignItems: "flex-start",
    textTransform: "none",
  },
  lastTab: {
    borderRight: "none",
    alignItems: "flex-start",
    textTransform: "none",
  },
};

const galleries = [
  {
    headText: "Ceremonies",
    headIcon: "/images/gallery/section-icon-ceremony.png",
    photos: [
      { src: "/images/gallery/SG-img-(68).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(67).jpg", width: 1301, height: 1920 },
      { src: "/images/gallery/Ceremony-(4).jpg", width: 1209, height: 1800 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_27.jpg", width: 1332, height: 2000 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_25.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Ceremony-(15).jpg", width: 1800, height: 1202 },
      { src: "/images/gallery/SG-img-(150).jpg", width: 1281, height: 1920 },
      { src: "/images/gallery/Feb-Ceremony-5-(Medium).jpg", width: 1152, height: 768 },
      { src: "/images/gallery/Ceremony-(14).jpg", width: 1200, height: 1800 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_33.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Ceremony-(8).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/SG-img-(81).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/SG-img-(15).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_14.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Ceremony-(10).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/SG-img-(42).jpg", width: 1920, height: 1281 },
      { src: "/images/gallery/Feb-Ceremony-2-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_04.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/SG-img-(122).jpg", width: 1281, height: 1920 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_22.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_02.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_19.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Ceremony-(1).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/Ceremony-(16).jpg", width: 1202, height: 1800 },
      { src: "/images/gallery/Feb-Ceremony-8-(Medium).jpg", width: 1152, height: 768 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_31.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_21.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/SG-img-(13).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_15.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/SG-img-(101).jpg", width: 1326, height: 1920 },
      { src: "/images/gallery/SG-img-(188).jpg", width: 1920, height: 1287 },
      { src: "/images/gallery/Feb-Ceremony-1-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_20.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(37).jpg", width: 1393, height: 1920 },
      { src: "/images/gallery/SG-img-(156).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_26.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_28.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Ceremony-(13).jpg", width: 1800, height: 1188 },
      { src: "/images/gallery/SG-img-(80).jpg", width: 1326, height: 1920 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_32.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_08.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_29.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(55).jpg", width: 1920, height: 1224 },
      { src: "/images/gallery/SG-img-(43).jpg", width: 1282, height: 1920 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_24.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(7).jpg", width: 1290, height: 1920 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_10.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/April-2024-Ceremony-2.jpg", width: 800, height: 1200 },
      { src: "/images/gallery/SG-img-(173).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/Ceremony-(2).jpg", width: 1800, height: 1198 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_16.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/Feb-Ceremony-3-(Medium).jpg", width: 1152, height: 768 },
      { src: "/images/gallery/April-2024-Ceremony-1.jpg", width: 800, height: 1200 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_13.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_11.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/SG-img-(12).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_36.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_30.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(104).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_05.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_01.jpg", width: 2048, height: 1365 },
      { src: "/images/gallery/SG-img-(172).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(11).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_09.jpg", width: 2048, height: 1365 },
      { src: "/images/gallery/SG-img-(19).jpg", width: 1920, height: 1202 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_03.jpg", width: 2048, height: 1365 },
      { src: "/images/gallery/SG-img-(82).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/Feb-Ceremony-4-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_07.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_23.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_17.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Feb-Ceremony-7-(Medium).jpg", width: 1152, height: 768 },
      { src: "/images/gallery/SG-img-(59).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_12.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/Ceremony-(11).jpg", width: 1200, height: 1800 },
      { src: "/images/gallery/Ceremony-(9).jpg", width: 1198, height: 1800 },
      { src: "/images/gallery/SG-img-(16).jpg", width: 1920, height: 1285 },
      { src: "/images/gallery/SG-img-(44).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/Ceremony-(6).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_34.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_06.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/Ceremony-(5).jpg", width: 1200, height: 1800 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_18.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/SG-img-(102).jpg", width: 1333, height: 1920 },
      { src: "/images/gallery/Ceremony-(7).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/SG-img-(3).jpg", width: 1920, height: 1281 },
      { src: "/images/gallery/SG-img-(58).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/Ceremony-(12).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_37.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/ceremony-new/SG_ceremony_gallery_june_2026_35.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/Ceremony-(17).jpg", width: 1202, height: 1800 },
      { src: "/images/gallery/Feb-Ceremony-6-(Medium).jpg", width: 1152, height: 768 },
      { src: "/images/gallery/Ceremony-(3).jpg", width: 1243, height: 1800 },
      { src: "/images/gina-nick/SG_ginanick_04.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_05.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_06.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_15.jpg", width: 1333, height: 2000 },
    ],
  },
  {
    headText: "Receptions",
    headIcon: "/images/gallery/section-icon-reception.png",
    photos: [
      { src: "/images/gallery/SG-img-(29).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/Feb-Reception-5-(Medium).jpg", width: 1152, height: 768 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_10.jpg", width: 2000, height: 1334 },
      { src: "/images/gallery/Reception-(8).jpg", width: 1201, height: 1800 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_07.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(21).jpg", width: 1920, height: 1920 },
      { src: "/images/gallery/Reception-(6).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/SG-img-(88).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(175).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(27).jpg", width: 1920, height: 1281 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_01.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/April-2024-Reception-2.jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/SG-img-(174).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(36).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(108).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/Reception-(14).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/Reception-(7).jpg", width: 1200, height: 1800 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_04.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(65).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(200).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(92).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_15.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Reception-(2).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/SG-img-(90).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(96).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_03.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Reception-(10).jpg", width: 1200, height: 1800 },
      { src: "/images/gallery/Feb-Reception-4-(Medium).jpg", width: 1152, height: 768 },
      { src: "/images/gallery/SG-img-(72).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/Feb-Reception-1-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gallery/Reception-(13).jpg", width: 1800, height: 1209 },
      { src: "/images/gallery/Feb-Reception-10-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_09.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/Feb-Reception-8-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gallery/SG-img-(20).jpg", width: 1920, height: 1920 },
      { src: "/images/gallery/SG-img-(83).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/April-2024-Reception-1.jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/Reception-(3).jpg", width: 1800, height: 1167 },
      { src: "/images/gallery/SG-img-(14).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/Reception-(1).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/Reception-(5).jpg", width: 1800, height: 1166 },
      { src: "/images/gallery/SG-img-(196).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/Reception-(11).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_08.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_02.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/SG-img-(35).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_13.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(198).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/SG-img-(118).jpg", width: 1920, height: 1282 },
      { src: "/images/gallery/SG-img-(202).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(89).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/SG-img-(32).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/Reception-(12).jpg", width: 1293, height: 1800 },
      { src: "/images/gallery/SG-img-(22).jpg", width: 1920, height: 1920 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_11.jpg", width: 2048, height: 1365 },
      { src: "/images/gallery/Feb-Reception-7-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gallery/SG-img-(54).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(28).jpg", width: 1920, height: 1237 },
      { src: "/images/gallery/SG-img-(94).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_06.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(181).jpg", width: 1920, height: 1920 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_05.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/SG-img-(170).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(87).jpg", width: 1920, height: 1247 },
      { src: "/images/gallery/SG-img-(26).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(76).jpg", width: 1329, height: 1920 },
      { src: "/images/gallery/SG-img-(5).jpg", width: 1920, height: 1281 },
      { src: "/images/gallery/SG-img-(145).jpg", width: 1333, height: 1920 },
      { src: "/images/gallery/Reception-(9).jpg", width: 1800, height: 1200 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_14.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/SG-img-(64).jpg", width: 1358, height: 1920 },
      { src: "/images/gallery/SG-img-(1).jpg", width: 1275, height: 1920 },
      { src: "/images/gallery/SG-img-(73).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(30).jpg", width: 1334, height: 1920 },
      { src: "/images/gallery/reception-new/SG_reception_gallery_june_2026_12.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/Feb-Reception-9-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gallery/SG-img-(197).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(24).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/SG-img-(205).jpg", width: 1920, height: 1280 },
      { src: "/images/gallery/SG-img-(201).jpg", width: 1280, height: 1920 },
      { src: "/images/gallery/SG-img-(142).jpg", width: 1283, height: 1920 },
      { src: "/images/gallery/Reception-(4).jpg", width: 1201, height: 1800 },
      { src: "/images/gallery/Feb-Reception-3-(Medium).jpg", width: 768, height: 1152 },
      { src: "/images/gina-nick/SG_ginanick_03.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_11.jpg", width: 1333, height: 2000 },
    ],
  },
  {
    headText: "Flowers & Decor",
    headIcon: "/images/gallery/section-icon-party.png",
    photos: [
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_38.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_14.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_29.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_30.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_18.jpg", width: 2000, height: 1335 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_27.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_42.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_61.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_20.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_46.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_52.jpg", width: 1334, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_34.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_60.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_24.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_31.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_25.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_51.jpg", width: 1334, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_19.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_43.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_05.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_28.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_53.jpg", width: 2000, height: 1334 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_03.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_15.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_04.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_40.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_13.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_47.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_11.jpg", width: 1334, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_54.jpg", width: 2000, height: 1334 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_06.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_44.jpg", width: 1334, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_01.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_39.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_59.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_36.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_55.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_57.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_48.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_23.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_33.jpg", width: 2000, height: 1335 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_41.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_56.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_32.jpg", width: 1335, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_26.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_49.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_37.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_07.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_16.jpg", width: 2000, height: 1336 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_02.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_08.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_58.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_09.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_22.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_35.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_10.jpg", width: 1334, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_45.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_12.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_17.jpg", width: 1335, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_21.jpg", width: 1334, height: 2000 },
      { src: "/images/gallery/flowers-decor/SG_florals_june_2026_50.jpg", width: 1333, height: 2000 },
    ],
  },
  {
    headText: "Dancefloor",
    headIcon: "/images/gallery/section-icon-dancefloor.png",
    photos: [
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_11.jpg", width: 1333, height: 2000 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_01.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_08.jpg", width: 2000, height: 1335 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_05.jpg", width: 2000, height: 1335 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_13.jpg", width: 1200, height: 801 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_01.jpg", width: 1333, height: 2000 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_12.jpg", width: 2000, height: 1333 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_03.jpg", width: 1000, height: 667 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_09.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_15.jpg", width: 2000, height: 1333 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_07.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_07.jpg", width: 2000, height: 1335 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_04.jpg", width: 2000, height: 1333 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_15.jpg", width: 2000, height: 1333 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_06.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_10.jpg", width: 2000, height: 1333 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_08.jpg", width: 1333, height: 2000 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_13.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_18.jpg", width: 2000, height: 1333 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_09.jpg", width: 2000, height: 1333 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_08.jpg", width: 2000, height: 1331 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_02.jpg", width: 1000, height: 667 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_04.jpg", width: 1333, height: 2000 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_10.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_16.jpg", width: 2000, height: 1333 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_07.jpg", width: 2000, height: 1331 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_03.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_12.jpg", width: 2000, height: 1333 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_05.jpg", width: 2000, height: 1335 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_06.jpg", width: 2000, height: 1334 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_09.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_01.jpg", width: 960, height: 720 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_04.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_03.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_17.jpg", width: 2000, height: 1333 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_05.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_14.jpg", width: 1438, height: 2000 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_13.jpg", width: 2000, height: 1333 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_06.jpg", width: 2000, height: 1331 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_10.jpg", width: 2000, height: 1335 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_14.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_02.jpg", width: 1333, height: 2000 },
      { src: "/images/great-hall/dance/SG_tgh_dance_june_2026_02.jpg", width: 1333, height: 2000 },
      { src: "/images/shepstone/dance/SG_shepstone_dance_june_2026_11.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/dancefloor-new/SG_dancefloor_new_june_2026_11.jpg", width: 2000, height: 1333 },
      { src: "/images/gina-nick/SG_ginanick_12.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_13.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_14.jpg", width: 1333, height: 2000 },
    ],
  },
  {
    headText: "Photo Opportunities",
    headIcon: "/images/gallery/section-icon-camera.png",
    photos: [
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_22.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_06.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_14.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_32.jpg", width: 1066, height: 1600 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_24.jpg", width: 1331, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_37.jpg", width: 1600, height: 1066 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_27.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_23.jpg", width: 1331, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_08.jpg", width: 1334, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_13.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_20.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_07.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_39.jpg", width: 1067, height: 1600 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_28.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_09.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_11.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_12.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_36.jpg", width: 1066, height: 1600 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_17.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_15.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_30.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_34.jpg", width: 1066, height: 1600 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_10.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_35.jpg", width: 1066, height: 1600 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_02.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_31.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_29.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_25.jpg", width: 1331, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_03.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_16.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_33.jpg", width: 1066, height: 1600 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_18.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_40.jpg", width: 1066, height: 1600 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_04.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_19.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_01.jpg", width: 2000, height: 1333 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_26.jpg", width: 1331, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_05.jpg", width: 1333, height: 2000 },
      { src: "/images/gallery/photo-ops/SG_gallery_photoops_june_2026_21.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_08.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_09.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_10.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_02.jpg", width: 1333, height: 2000 },
      { src: "/images/gina-nick/SG_ginanick_01.jpg", width: 1600, height: 1067 },
    ],
  },
];


const Gallery = () => {

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Helmet>
        <title>Gallery | The Shepstone Experience</title>
        <meta
          name={"description"}
          content={"Get an idea of how your dream can be a reality at Shepstone Gardens & The Great Hall with these amazing photos."}
        ></meta>
      </Helmet>

      <Header
        bgImg={"/images/gallery-header-3.jpg"}
        headText={"DREAMS THAT HAVE COME TRUE"}
      />

      <section className={"gallery-section"}>
        <div className={"gal-outer-cont standard-width"}>
          <Tabs
            value={value}
            onChange={handleChange}
            style={styles.tabs}
            indicatorColor={"secondary"}
            variant={"fullWidth"}
            centered
          >
            {
              galleries.map((gallery, index) => (
                <Tab
                  key={index}
                  style={(index === (galleries.length - 1)) ? styles.lastTab : styles.tab}
                  label={
                    <React.Fragment>
                      <div className={"team-head-icon-cont"}>
                        <img
                          className={"team-head-icon"}
                          src={gallery.headIcon}
                        />
                      </div>
                      {gallery.headText}
                    </React.Fragment>
                  }
                />
              ))
            }
          </Tabs>
        
          {
            galleries.map((gallery, index) => (
              <GalleryTab
                key={index}
                photos={gallery.photos}
                isActive={(value === index)}
              />
            ))
          }
        </div>
      </section>

      <LineSeparator noLine />

      <LineSeparator />
      <Contact />
    </div>
  );
};

export default Gallery;